/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// (function(){
// 	'use strict';

// 	function applyFilter(select){
// 		if(!select) return;
// 		function update(){
// 			var val = select.value;
// 			var items = document.querySelectorAll('.finance-item');
// 			items.forEach(function(it){
// 				var y = it.getAttribute('data-year');
// 				if(val === 'all' || !val){
// 					it.style.display = '';
// 				} else if(String(y) === String(val)){
// 					it.style.display = '';
// 				} else {
// 					it.style.display = 'none';
// 				}
// 			});
// 		}
// 		select.addEventListener('change', update);
// 		update();
// 	}

// 	if(document.readyState === 'loading'){
// 		document.addEventListener('DOMContentLoaded', function(){
// 			applyFilter(document.querySelector('select#finance-year-select'));
// 		});
// 	} else {
// 		applyFilter(document.querySelector('select#finance-year-select'));
// 	}
// })();
